export const ROOM_MESSAGE = 'ROOM_MESSAGE';
export const STATUS_MOTD = 'STATUS_MOTD';

export const MESSAGE_GENERAL = 'message';
export const MESSAGE_MOTD = 'motd';


// WEBPACK FOOTER //
// ./src/constants/roomMessages.js